import { useCallback, useLayoutEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getCommonTabs } from '@shared/helpers/index.ts';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import { useUser } from '@shared/hooks/use-user.ts';
import type { ActiveTabType } from '@shared/types/common';

export const useListTabs = () => {
  const { isAuth } = useUser();
  const [searchParams, setSearchParams] = useSearchParams();
  const { permissions } = useModuleByCodeParam();
  const activeTab = useMemo(() => searchParams.get('tab') as ActiveTabType, [searchParams]);

  const tabs = useMemo(
    () => getCommonTabs({ isAuth, can_sell: permissions.can_sell }),
    [isAuth, permissions]
  );

  const onTabClick = useCallback(
    (tab: ActiveTabType) => {
      searchParams.set('tab', tab);
      setSearchParams(searchParams);
    },
    [searchParams, setSearchParams]
  );

  useLayoutEffect(() => {
    if (!activeTab) {
      onTabClick('all');
    }
  }, [activeTab, onTabClick]);

  return {
    tabs,
    activeTab,
    onTabClick,
  };
};
